export const START_FETCH_APP = "biz/application/START_FETCH_APP";
export const SUCCESS_FETCH_APP = "biz/application/SUCCESS_FETCH_APP";

export const START_CREATE = "biz/application/START_CREATE";
export const SUCCESS_CREATE = "biz/application/SUCCESS_CREATE";

export const START_DESTROY = "biz/application/START_DESTROY";
export const SUCCESS_DESTROY = "biz/application/SUCCESS_DESTROY";

export const START_COMPILE = "biz/application/START_COMPILE";
export const SUCCESS_COMPILE = "biz/application/SUCCESS_COMPILE";

export const START_INIT = "biz/application/START_INIT";
export const SUCCESS_INIT = "biz/application/SUCCESS_INIT";

export const START_BUILD_BACKEND = "biz/application/START_BUILD_BACKEND";
export const SUCCESS_BUILD_BACKEND = "biz/application/SUCCESS_BUILD_BACKEND";

export const START_START = "biz/application/START_START";
export const SUCCESS_START = "biz/application/SUCCESS_START";

export const START_STOP = "biz/application/START_STOP";
export const SUCCESS_STOP = "biz/application/SUCCESS_STOP";

export const START_PINGING = "biz/application/START_PINGING"; // saga
export const DO_START_PINGING = "biz/application/DO_START_PINGING"; // reducer

export const FAIL_PING = "biz/application/FAIL_PING"; // kind of 'normal', just try again after delay()
export const SUCCESS_PING = "biz/application/SUCCESS_PING";
export const PINGING_TIMEOUT = "biz/application/PINGING_TIMEOUT"; // ping really failed now

export const HEARTBEAT_START = "biz/application/HEARTBEAT_START";
export const HEARTBEAT_SUCCESS = "biz/application/HEARTBEAT_SUCCESS";
export const HEARTBEAT_FAILURE = "biz/application/HEARTBEAT_FAILURE";
export const HEARTBEAT_STOP = "biz/application/HEARTBEAT_STOP";

export const LAUNCH_START = "biz/application/START_LAUNCH";
export const LAUNCH_SUCCESS = "biz/application/START_LAUNCH";

export const START_BUILD = "biz/application/START_BUILD";
// export const END_BUILD = "biz/application/END_BUILD";

export const ERROR = "biz/application/ERROR";

export const OPTIMISTIC_START = "biz/application/OPTIMISTIC_START";
export const RESET = "biz/application/RESET";

export const CHECK_PENDING = "biz/application/CHECK_PENDING";
export const SET_PHASE_STATUS = "biz/application/SET_PHASE_STATUS";
